{
  "eyebrow": "Pasirinkite planą",
  "title": "Planas, tinkamas Jūsų komandos darbo būdui.",
  "sub": "30 dienų nemokamas bandymas visiems planams. Be kredito kortelės. Atšaukite bet kada.",
  "bill": {
    "month": "Mėnesinis",
    "year": "Metinis",
    "save": "Sutaupykite 15%"
  },
  "fam": {
    "time": "Laikas ir veikla",
    "project": "Projektai ir sąnaudų kontrolė"
  },
  "compare": "Palyginti visas funkcijas",
  "compareHide": "Slėpti palyginimą",
  "included": "Įskaičiuota",
  "select": "Pasirinkti {{plan}}",
  "selected": "Pasirinkta",
  "recommended": "Populiariausias",
  "pricePerMonth": "/ naudotojas / mėn.",
  "pricePerYear": "/ naudotojas / metai",
  "base": "bazinis / mėn.",
  "admins": "2 administratoriai įskaičiuoti",
  "continueCta": "Tęsti su {{plan}}",
  "continuePick": "Pasirinkite planą, kad galėtumėte tęsti",
  "catalogError": "Kainoraštis nepasiekiamas. Bandykite dar kartą, kad būtų įkelti naujausi kainos.",
  "plans": {
    "timeBasic": "Time Basic",
    "timePro": "Time Pro",
    "projectBasic": "Project Basic",
    "projectPro": "Project Pro",
    "timeBasicBest": "Atitiktis ir paprasta apskaita",
    "timeProBest": "Komandos veikla",
    "projectBasicBest": "Projektai ir sąnaudų kontrolė",
    "projectProBest": "Pažangus projektų valdymas",
    "feat": {
      "timeBasic": {
        "timeTracking": "Darbo laiko registracija",
        "absencesHolidays": "Neatvykimai ir atostogos",
        "transport": "Transporto žurnalai",
        "workLocations": "Darbo vietos ir GPS",
        "mobileApp": "Mobilioji programėlė darbuotojams lauke"
      },
      "timePro": {
        "everythingTime": "Viskas iš Time Basic",
        "overtime": "Viršvalandžių registracija",
        "scheduling": "Pamainų planavimas",
        "documents": "Darbuotojų dokumentai",
        "officeOps": "Biuro funkcijos (veiklos žurnalas, pataisos)",
        "addonsAvailable": "Galimi priedai: projektų stebėjimas, VTT",
        "internalMessaging": "Vidinis susirašinėjimas (įmonės pokalbiai)"
      },
      "projectBasic": {
        "everythingTime": "Viskas iš Time Basic",
        "projects": "Projektai su išlaidų kontrole",
        "extras": "Papildomi darbai ir medžiagos",
        "subcontractors": "Subrangovų valdymas",
        "checkInOut": "Darbuotojų atvykimas / išvykimas",
        "internalMessaging": "Vidinis susirašinėjimas (įmonės pokalbiai)"
      },
      "projectPro": {
        "everythingAll": "Viskas iš Time Pro + Project Basic",
        "projectTransport": "Transportas pagal projektą",
        "fullSuite": "Pilnas produktyvumo rinkinys",
        "prioritySupport": "Prioritetinis palaikymas",
        "internalMessaging": "Vidinis susirašinėjimas (įmonės pokalbiai)"
      }
    },
    "timeZero": "Time Zero"
  },
  "comparison": {
    "title": "Palyginti visas funkcijas",
    "subtitle": "Viskas, ką apima kiekvienas planas, greta.",
    "cat": {
      "timeAttendance": "Laikas ir dalyvavimas",
      "projectCost": "Projektai ir išlaidų kontrolė",
      "support": "Pagalba"
    },
    "val": {
      "upTo4": "Iki 4",
      "unlimited": "Neribota",
      "soon": "Netrukus",
      "optional": "Pasirinktinai",
      "years5": "5 metai",
      "years10": "10 metų"
    },
    "row": {
      "mobileDesktop": "Mobilioji ir kompiuterio programa",
      "gpsCheckin": "Registracija vienu paspaudimu su GPS",
      "holidayAbsenceOvertime": "Atostogos, nebuvimas ir viršvalandžiai",
      "teamMembers": "Komandos nariai",
      "workLocations": "Darbo vietos",
      "registrationsPerMonth": "Registracijos / naudotojas / mėnuo",
      "irregularMap": "Netaisyklinga registracija žemėlapyje",
      "expenseManagement": "Išlaidų valdymas",
      "employeeDocuments": "Darbuotojų dokumentai",
      "openApi": "Atviras API",
      "navigation": "Navigacija į darbo vietas",
      "projectManagement": "Projektų valdymas (biudžetas)",
      "subprojects": "Subprojektai",
      "subcontractorManagement": "Subrangovų valdymas",
      "extraWorkMaterials": "Papildomi darbai ir medžiagos",
      "transportProjects": "Transportas, susietas su projektais",
      "fullSuite": "Visas produktyvumo rinkinys",
      "prioritySupport": "Prioritetinė pagalba",
      "languages12": "Prieinama 12 kalbų",
      "manualTransport": "Rankinis transporto atstumas",
      "reportsExcel": "Ataskaitos ir eksportas į „Excel“",
      "frontendLocations": "Vietos, sukurtos programėlės naudotojų",
      "checkInWork": "Check-in/out@work (Belgija)",
      "vehicleTracking": "Vehicle Track & Trace",
      "projectDescriptions": "Projektų aprašymai ir nuotraukos",
      "dataStorage": "Duomenų saugojimas",
      "schedulingPlanning": "Planavimas",
      "messagingNotifications": "Pranešimai · Iššoktantieji pranešimai"
    }
  }
}
